import { useQuery } from "@tanstack/react-query";
import {
  getUserAgency,
  getUserDoctor,
  getUserExpert,
  getUserHospital,
} from "apis/users";
import QUERY_KEYS from "config/queryKey";
import { useMemo } from "react";

function useUserInfoCard() {
  const userInfo = localStorage.getItem("userInfo") || "";
  const userType = JSON.parse(userInfo)?.userType || "";

  const { data: userDoctorData } = useQuery({
    queryKey: [QUERY_KEYS.user, userType],
    queryFn: getUserDoctor,
    enabled: userType === "DOCTOR",
  });

  const { data: userAgencyData } = useQuery({
    queryKey: [QUERY_KEYS.user, userType],
    queryFn: getUserAgency,
    enabled: userType === "AGENCY",
  });

  const { data: userExpertData } = useQuery({
    queryKey: [QUERY_KEYS.user, userType],
    queryFn: getUserExpert,
    enabled: userType === "EXPERT",
  });

  const { data: userHospitalData } = useQuery({
    queryKey: [QUERY_KEYS.user, userType],
    queryFn: getUserHospital,
    enabled: userType === "HOSPITAL",
  });

  const userData = useMemo(() => {
    switch (userType) {
      case "DOCTOR": {
        const { email, name, nickname, phone, department } =
          userDoctorData || {};
        return { email, name, nickname, phone, department, type: "의사" };
      }
      // case "EXPERT": {
      //   const { email, name, phone } = userExpertData || {};
      //   return { email, name, phone, type: "전문가 회원" };
      // }
      case "AGENCY": {
        const { email, name, nickname, agencyName, region, thumbnail, phone } =
          userAgencyData || {};
        return {
          email,
          name,
          nickname,
          agencyName,
          region,
          thumbnail,
          phone,
          type: "전문가",
        };
      }
      case "HOSPITAL": {
        const { email, name, nickname, hospitalName, phone, address } =
          userHospitalData || {};
        return {
          email,
          name,
          nickname,
          hospitalName,
          phone,
          address,
          type: "병/의원",
        };
      }
      default:
        return {};
    }
  }, [
    userAgencyData,
    userDoctorData,
    userExpertData,
    userHospitalData,
    userType,
  ]);

  return { userData };
}

export default useUserInfoCard;
